import React, {
  useState,
  useEffect,
  useCallback,
  useReducer,
  useRef,
  Fragment,
} from "react";
import Box from "@mui/material/Box";
import { Skeleton, Typography } from "@mui/material";
import MuiTab from "../../CommonComponents/Tab/MuiTab";
import CommonDescription from "../../CommonComponents/CommonDescription";
import useMediaQuery from "@mui/material/useMediaQuery";
import TableComponent from "../../CommonComponents/Table";
import CommonButton from "../../CommonComponents/CommonButton";
import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
//import DownloadIcon from "@mui/icons-material/Download";
import DownloadIcon from "../../Images/Svg/DownloadIcon.svg";
import TableGrid from "../../CommonComponents/TableGridView/TableGrid";
import {
  tabsApproval,
  tabs2Approval,
  ApprovalTableData,
  tabValuePairing,
} from "../../constants/approvalsData";
import {
  approvalActionList,
  invoiceApprovalActionList,
  defaultCaseActionList,
  motorTriggerTable,
  segmentInfoDetails,
} from "../../constants/utils";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import RaiseQueryModal from "../CaseManagement/Actions/RaiseQueryModal";
import DragDrop from "../../CommonComponents/DragDrop/DragDrop";
import ReAssignModal from "../CaseManagement/Actions/ReAssign";
import GradeCaseModal from "../CaseManagement/Actions/GradeCase";
import CaseDescriptionElement from "../CaseManagement/Actions/CaseDescription/CaseDescriptionElement";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import FilterPopOver from "../CaseManagement/CaseManagementFilter/FilterPopOver";
import style from "./Approval.module.css";
import {
  approvalDateReducer,
  filterStatusReducer,
} from "../../Redux/Slice/FilterSlice";
import Investigation from "./Investigation/Investigation";
import ApprovalAction from "../CaseManagement/Actions/Approval";
import Reject from "../CaseManagement/Actions/Reject";
import { pageLimit } from "../../Utils/helper";
import {
  approvalFlagPutApi,
  approvedAll,
  deEmpanelBlacklist,
  getAllApprovalCasesList,
  getAllApprovalCasesSegmentInfo,
  getInvoiceList,
  rejectAll,
} from "../../Services/approval.service";
import { caseDescriptionPut } from "../../Services/caseManagement.service";
import ExternalInformation from "../../CommonComponents/ExternalInformation";
import useToaster from "../../customHook/useToaster";
import VendorAssesment from "../CaseManagement/Actions/AssesmentCalculator";
import { storeCaseId } from "../../Redux/Slice/CaseManagementActionsSlice/CaseDescriptionSlice";
import ApprovalModal from "../CaseManagement/Actions/Approval";
import {
  RLMUActionsTabelData,
  hospitalDeEmpanelmentApprovalTableData,
} from "../../constants/sampleData";
import DeEmpanelHospital from "../../CommonComponents/DeEmpanelHospital";
import RecommendationTabelGrid from "../../CommonComponents/TableGridView/RecommendationTabelGrid";
import { getRlmuData } from "../../Services/de-empanel.service";
import { debounce } from "lodash";
import TableSkeleton from "../../CommonComponents/TableSkeleton";
import TableGridSkeleton from "../../CommonComponents/TableGridSkeleton";
import UploadDocument from "../CaseManagement/Actions/UploadDoucument/UploadDocument";
import PeerReview from "../CaseManagement/Actions/PeerReview/PeerReview";

const Approval = () => {
  const [page, setPage] = useState(1);
  const [rerenderApprovalCaseList, setRerenderApprovalCaseList] =
    useState(false);
  const [rerenderSegmentApiState, setRerenderSegmentApiState] = useState(false);
  const [firstTabIndex, setFirstTabIndex] = useState(0);

  const [secondTabVal, setSecondTabVal] = useState("");

  const [secondTabIndex, setSecondTabIndex] = useState(0);
  const [isSubmitActive, setIsSubmitActive] = useState(true);
  const [tableCollapseDataState, setTableCollapseDataState] = useState([]);
  const [openCollapse, setOpenCollapse] = useState();
  const [selectedCollapseId, setSelectedCollapseId] = useState(0);
  const [firstTabVal, setFirstTabVal] = useState("Case");
  const [displaySecondTab, setDisplaySecondTab] = useState(false);
  const [openActionModal, setOpenActionModal] = useState(false);
  const [actionModalType, setActionModalType] = useState("");
  const [actionTabState, setActionTabState] = useState([]);
  const [approvalDataState, setApprovalDataState] = useState([]);
  const [approvalSegmentInfoState, setApprovalSegmentInfoState] = useState({});
  const [count, setCount] = useState(0);
  const rowsPerPage = pageLimit;
  const { showToast } = useToaster();
  //filter state
  const [isDateFilterClicked, setisDateFilterClicked] = useState(false);
  const [isStatusFilterClicked, setisStatusFilterClicked] = useState(false);
  const [isDateIconClicked, setisDateIconClicked] = useState(false);
  const [isStatusIconClicked, setisStatusIconClicked] = useState(false);
  const [isStatusItemClicked, setisStatusItemClicked] = useState(false);
  const [filterSearchData, setFilterSearchData] = useState("");
  const [activeCaseId, setActiveCaseId] = useState("");
  const [investigationsActiveTabValue, setInvestigationActiveTabValue] =
    useState(-1);
  const [vendorBlockisClicked, setVendorBlockIsClicked] = useState(false);
  const [isVendorClicked, setIsVendorClicked] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [rlmuData, setRlmuData] = useState([]);
  const [isStandardTable, setIsStandardTable] = useState(false);
  const [showSkeleton, setShowSkeleton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matches = useMediaQuery("(min-width:1200px)"); //new
  const viewTableRef = useRef(null);
  const selectedCaseId = useRef(0);
  const actionPopperRef = useRef(null);
  const descriptionRef = useRef("");
  const currentRole = useSelector(
    (state) => state?.loginSlice?.userData?.currentRoleName
  );

  const { caseId, lobName } = useSelector(
    (state) => state?.CaseDescriptionSlice
  );

  // table

  const onCellClicked = useCallback((e, colid, colValue, lobName, index) => {
    if (typeof colValue === "number") {
      selectedCaseId.current = colValue;
      dispatch(storeCaseId({ colValue, lobName }));
    }
    setSelectedCollapseId(index);
  }, []);

  const onSubmitButton = async (event, newValue) => {
    try {
      if (
        secondTabVal === "Recommendation" &&
        !descriptionRef?.current?.value
      ) {
        return showToast("Please provide remark.", "error", true);
      }
      const data = await caseDescriptionPut(
        secondTabVal === "CHASE Smart"
          ? "External"
          : secondTabVal.split(" ")[0],
        {
          caseId: selectedCaseId.current,
          description: descriptionRef?.current?.value || "",
        },
        firstTabVal
      );
      if (data?.success) {
        if (secondTabVal === "Recommendation") {
          setRerenderApprovalCaseList((prev) => !prev);
          setRerenderSegmentApiState((prev) => !prev);
        }
        showToast(data?.message, "success", true);
      } else {
        showToast(
          data?.message || "Error in updating description",
          "error",
          true
        );
      }
    } catch (error) {
      showToast(
        error?.response?.data?.message || "Error in updating description",
        "error",
        true
      );
    }
  };

  const firstButtonClicked = useCallback(() => {
    setPage(1);
  }, []);
  const lastButtonClicked = useCallback(() => {
    setPage(Math.ceil(count / rowsPerPage));
  }, [rowsPerPage, count]);
  const handleNextButtonClick = useCallback(() => {
    setPage((page) => page + 1);
  }, []);
  const handleBackButtonClick = useCallback(() => {
    setPage((page) => page - 1);
  }, []);
  const onPageDropdownChange = useCallback((e) => {
    setPage(Number(e.target.value));
  }, []);
  const secondTabChangeClickHandler = useCallback((event, newValue) => {
    setApprovalSegmentInfoState({});
    setSecondTabVal(event.target.innerText);
    setSecondTabIndex(newValue);
    setSelectedCollapseId(null);
    setOpenCollapse(false);
  }, []);
  const firstTabChangeClickHandler = useCallback((event, newValue) => {
    setApprovalDataState([]);
    setFirstTabVal(event.target.innerText.split(" ")[0]);
    setFirstTabIndex(newValue);
    setDisplaySecondTab(false);
    setSecondTabIndex(0);
    setSelectedCollapseId(null);
    setPage(1);
  }, []);

  // function caseNumberClick(e, ref) {
  //   setDisplaySecondTab(true);
  //   setSecondTabVal("Investigation");
  //   setSecondTabIndex(0);
  //   setSelectedCollapseId(null);
  // }
  const gridViewTabs = [
    "Basic Details",
    "Policy Details",
    "Proposal Details",
    "Risk Details",
    // "CHASE Smart",
    "Vendor Details",
    "Statutory Details",
    "Company Reg. No.",
    "Bank Details",
    "Nature of Firm",
    "Upload Doc",
    "Product Mapping",
    "Sub-Product",
  ];

  const flagApiFun = async () => {
    try {
      const data = await approvalFlagPutApi(selectedCaseId.current, {
        star: true,
      });
      if (data.success) {
        showToast("Case flagged", "success", true);
        setRerenderApprovalCaseList((prev) => !prev);
      } else {
        showToast("Error in case flagged", "error", true);
      }
    } catch (error) {
      showToast("Error In Flaging case", "error", true);
    }
  };

  const ActionTabContent = useCallback((firstTabVal) => {
    switch (firstTabVal) {
      case "Case":
        setActionTabState(approvalActionList);
        break;
      case "Invoice":
        setActionTabState(invoiceApprovalActionList);
        break;
      case "Hospital":
        setActionTabState(invoiceApprovalActionList);
        break;
      case "Garage":
        setActionTabState(invoiceApprovalActionList);
        break;
      case "Police":
        setActionTabState([]);
        break;
      case "Vendor":
        setActionTabState([]);
        break;
      default:
        setActionTabState(defaultCaseActionList);
    }
  }, []);

  const onClickFirstPopper = useCallback(
    async (e, type) => {
      setActiveCaseId(selectedCaseId.current);
      if (type === "view") {
        setInvestigationActiveTabValue(-1);
        setVendorBlockIsClicked(false);
        setIsVendorClicked(false);
        setDisplaySecondTab(true);
        setSecondTabVal(
          firstTabIndex == 2 || firstTabIndex == 3
            ? "Recommendation"
            : "Investigation"
        );
        setSecondTabIndex(0);
        setSelectedCollapseId(null);
        setRerenderSegmentApiState((prev) => !prev);
        setTimeout(() => {
          viewTableRef?.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        }, 350);
      } else {
        if (type === "Flag") {
          await flagApiFun();
        } else {
          setOpenActionModal(true);
          setActionModalType(type);
          actionPopperRef.current = {
            caseId: selectedCaseId?.current,
            open: true,
          };
        }
      }
    },
    [firstTabIndex]
  );

  const unFlagApiClick = useCallback(async (caseId) => {
    try {
      const data = await approvalFlagPutApi(caseId, {
        star: false,
      });
      if (data.success) {
        showToast("Case unflagged", "success", true);
        setRerenderApprovalCaseList((prev) => !prev);
      } else {
        showToast("Error in case flagged", "error", true);
      }
    } catch (error) {
      showToast("Error In Flaging case", "error", true);
    }
  }, []);
  // const onClickSecondPopper = useCallback(
  //   async (e, type) => {
  //     if (type === "Flag") {
  //       try {
  //         const data = await approvalFlagPutApi(selectedCaseId, {
  //           star: true,
  //         });
  //         if (data.success) {
  //           showToast("Case flagged", "success", true);
  //           setRerenderApprovalCaseList((prev) => !prev);
  //         } else {
  //           showToast("Error in case flagged", "error", true);
  //         }
  //
  //       } catch (error) {
  //         showToast("Error In Flaging case", "error", true);
  //
  //       }
  //     } else {
  //       setOpenActionModal(true);
  //     }
  //     setActionModalType(type);
  //   },
  //   [selectedCaseId, showToast]
  // );
  const onCloseSecondPopper = useCallback(() => {}, []);
  const newCaseClickHandler = useCallback(() => {
    navigate("/createCase");
  }, []);

  const deEmpanelIds = () => {
    let ids = approvalDataState
      ?.map((item) => {
        if (selectedCaseId?.current === item?.case_id) {
          return item?.garageids || item?.hospitalids;
        }
        return null; //  handle the case where the condition is not met
      })
      .filter((id) => id !== null); // Filter out null values

    return ids[0];
  };

  const onSubmitApprovedModalHandler = (remarkkVal) => {
    if (firstTabVal === "Invoice") {
      let data = {
        invoice_remark: remarkkVal,
      };
      approvedAll(selectedCaseId.current, data)
        .then((res) => {
          if (res?.success) {
            showToast(res?.message, "success", true);
            setRerenderApprovalCaseList((prev) => !prev);
            setOpenActionModal(false);
            setDisplaySecondTab(false);
          }
        })
        .catch((error) => {
          showToast(error?.message, "error", true);
          setOpenActionModal(false);
        });
    }
    if (firstTabVal === "Garage") {
      let data = {
        garageIds: deEmpanelIds(),
        decision: "1", // decision 1 means approved
        caseId: selectedCaseId?.current,
        remarks: remarkkVal,
      };
      deEmpanelBlacklist(data, "garage")
        .then((res) => {
          if (res?.success) {
            showToast(res?.data, "success", true);
            setRerenderApprovalCaseList((prev) => !prev);
            setOpenActionModal(false);
            setRerenderSegmentApiState((prev) => !prev);
          }
        })
        .catch((error) => {
          showToast(error?.message, "error", true);
          setOpenActionModal(false);
        });
    }
    if (firstTabVal === "Hospital") {
      let data = {
        hospitalIds: deEmpanelIds(),
        decision: "1", // decision 1 means approve
        caseId: selectedCaseId?.current,
        remarks: remarkkVal,
      };
      deEmpanelBlacklist(data, "hospital")
        .then((res) => {
          if (res?.success) {
            showToast(res?.data, "success", true);
            setRerenderApprovalCaseList((prev) => !prev);
            setOpenActionModal(false);
            setRerenderSegmentApiState((prev) => !prev);
          }
        })
        .catch((error) => {
          showToast(error?.message, "error", true);
          setOpenActionModal(false);
        });
    }
  };

  const onSubmitRejectHandler = (remarkkVal) => {
    if (firstTabVal === "Invoice") {
      let data = {
        invoice_remark: remarkkVal,
      };
      rejectAll(selectedCaseId.current, data)
        .then((res) => {
          if (res?.success) {
            showToast(res?.message, "success", true);
            setRerenderApprovalCaseList((prev) => !prev);
            setOpenActionModal(false);
            setDisplaySecondTab(false);
          }
        })
        .catch((error) => {
          showToast(error?.message, "error", true);
          setOpenActionModal(false);
        });
    }
    if (firstTabVal === "Garage") {
      let data = {
        garageIds: deEmpanelIds(),
        decision: "0", // decision 0 means reject
        caseId: selectedCaseId?.current,
        remarks: remarkkVal,
      };
      deEmpanelBlacklist(data, "garage")
        .then((res) => {
          if (res?.success) {
            showToast(res?.data, "success", true);
            setRerenderApprovalCaseList((prev) => !prev);
            setOpenActionModal(false);
            setRerenderSegmentApiState((prev) => !prev);
          }
        })
        .catch((error) => {
          showToast(error?.message, "error", true);
          setOpenActionModal(false);
        });
    }
    if (firstTabVal === "Hospital") {
      let data = {
        hospitalIds: deEmpanelIds(),
        decision: "0", // decision 0 means reject
        caseId: selectedCaseId?.current,
        remarks: remarkkVal,
      };
      deEmpanelBlacklist(data, "hospital")
        .then((res) => {
          if (res?.success) {
            showToast(res?.data, "success", true);
            setRerenderApprovalCaseList((prev) => !prev);
            setOpenActionModal(false);
            setRerenderSegmentApiState((prev) => !prev);
          }
        })
        .catch((error) => {
          showToast(error?.message, "error", true);
          setOpenActionModal(false);
        });
    }
  };

  const actionFactory = useCallback(
    (x) => {
      let component = null;
      switch (x) {
        case "Approve":
          component = (
            <ApprovalAction
              isRemark
              isRemarkRequired
              remarkLabel="Remark"
              remarkPlaceholder="Enter Remark"
              onClick={setOpenActionModal}
              onSubmit={onSubmitApprovedModalHandler}
            />
          );
          break;
        case "Reject":
          component = (
            <ApprovalAction
              isRemark
              isRemarkRequired
              remarkLabel="Remark"
              remarkPlaceholder="Enter Remark"
              onClick={setOpenActionModal}
              onSubmit={onSubmitRejectHandler}
              message="Are you sure you want to reject ?"
            />
          );
          break;
        case "Vendor Assessment":
          component = (
            <VendorAssesment
              setOpenActionModal={setOpenActionModal}
              caseId={selectedCaseId.current}
            />
          );
          break;
        case "Grade Case":
          component = (
            <GradeCaseModal setOpenActionModal={setOpenActionModal} />
          );
          break;
        case "Upload Documents":
          component = (
            <UploadDocument onSuccess={() => setOpenActionModal(false)} />
          );
          break;
        case "Submit Final":
          component = (
            <ApprovalModal
              message="Do you have any recommendations?"
              onClick={(value) => {
                setOpenActionModal(value);
                setRerenderApprovalCaseList((prev) => !prev);
              }}
              displaySecondTab={() => setDisplaySecondTab(false)}
              isSubmit={true}
            />
          );
          break;
        case "Peer Review":
          component = (
            <PeerReview
              caseId={caseId}
              onSuccess={() => setOpenActionModal(false)}
            />
          );
          break;
        default:
          return "Failed to load";
      }
      return component;
    },
    [firstTabVal, deEmpanelIds]
  );

  const renderActionComponent = useCallback(() => {
    return actionFactory(actionModalType);
  }, [actionFactory, actionModalType]);

  const dateFilterHandler = () => {
    setisDateFilterClicked(!isDateFilterClicked);
    setisDateIconClicked(!isDateIconClicked);
  };
  const statusFilterHandler = () => {
    setisStatusIconClicked(!isStatusIconClicked);
    setisStatusFilterClicked(!isStatusFilterClicked);
  };
  const statusItemHandler = (option) => {
    setisStatusItemClicked(true);
  };
  const startDateHandler = (value) => {
    // let d = new Date(value);
    // d = `${d.getMonth() + 1}-${d.getDate()}-${d.getFullYear()}`;
    dispatch(approvalDateReducer({ approvalStartDate: value }));
  };
  const endDateHandler = (value) => {
    // let d = new Date(value);
    // d = `${d.getMonth() + 1}  -${d.getDate()}-${d.getFullYear()}`;
    dispatch(approvalDateReducer({ approvalEndDate: value }));
  };
  const handleFilterByTag = (e) => {
    if (e.keyCode === 13) {
      setFilterSearchData(e.target.value);
    }
  };

  const handleClick = (event) => {
    return showToast("Coming soon", "info", true);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleFilterReset = () => {
    setFilterSearchData("");
    dispatch(
      approvalDateReducer({ approvalStartDate: "", approvalEndDate: "" })
    );
    dispatch(filterStatusReducer(""));
  };
  const handleFilterApply = (e) => {
    setAnchorEl(null);
  };

  const getAllApprovalCasesSegmentInfoFun = useCallback(
    async (secondTabVal) => {
      if (
        secondTabVal &&
        secondTabVal !== "Investigation" &&
        secondTabVal !== "FCU Actions"
      ) {
        try {
          const data = await getAllApprovalCasesSegmentInfo(
            secondTabVal === "CHASE Smart"
              ? "External"
              : secondTabVal.split(" ")[0],
            {
              caseId: selectedCaseId.current,
            },
            firstTabVal
          );

          if (data?.success) {
            setShowSkeleton(true);
            // if (!isRerendered)
            //   showToast("Segment Info Fetched", "success", true);
            let caseManagementSegmentInfoData = data.data;
            if (secondTabVal === "Claim Details") {
              let documentsData = data?.data?.publicUrls;
              caseManagementSegmentInfoData = data.data.claimResult.map(
                (item, i, arr) => {
                  arr[i] = {
                    ...arr[i],
                    view_details: "View Details",
                    create_case: "Create Case",
                    documents: documentsData,
                    srNo: i + 1,
                  };
                  return arr[i];
                }
              );
            } else if (secondTabVal === "Risk Details") {
              caseManagementSegmentInfoData.triggers =
                caseManagementSegmentInfoData?.trigger?.map((item, index) => ({
                  ...item,
                  srNo: index + 1,
                })) || [];
            } else if (
              secondTabVal === "Dispatch Details" ||
              secondTabVal === "Endorsement Details"
            ) {
              caseManagementSegmentInfoData = data.data.map((item, i, arr) => {
                arr[i] = {
                  ...arr[i],
                  view_details: "View Details",
                  srNo: i + 1,
                };
                return arr[i];
              });
            }
            setApprovalSegmentInfoState(caseManagementSegmentInfoData);
            if (
              caseManagementSegmentInfoData?.case_description &&
              descriptionRef.current
            ) {
              descriptionRef.current.value =
                caseManagementSegmentInfoData?.case_description;
            } else if (
              caseManagementSegmentInfoData[0] &&
              caseManagementSegmentInfoData[0]?.case_description &&
              descriptionRef.current
            ) {
              descriptionRef.current.value =
                caseManagementSegmentInfoData[0]?.case_description;
            } else if (
              secondTabVal === "Recommendation" &&
              descriptionRef.current
            ) {
              // let activeCaseData = approvalDataState?.find(
              //   (obj) => obj?.case_id == selectedCaseId?.current
              // );
              // let recommendation = activeCaseData?.recommendation?.trim();
              // setIsSubmitActive(false);
              descriptionRef.current.value = "";
            } else if (descriptionRef.current) {
              descriptionRef.current.value = "";
            }
          } else {
            setApprovalSegmentInfoState({});
            showToast("Error In Fetching Segment Info", "error", true);
          }
        } catch (error) {
          setApprovalSegmentInfoState({});
          showToast("Error In Fetching Segment Info", "error", true);
        }
      } else if (secondTabVal && secondTabVal === "FCU Actions") {
        getRlmuData(selectedCaseId?.current)
          .then((res) => {
            if (res?.success) {
              setRlmuData(res?.data);
            }
          })
          .catch((error) => showToast(error?.message, "erroe", true));
      }
    },
    [firstTabVal, showToast]
  );

  const debounceSegmentsApiCall = useCallback(
    debounce(getAllApprovalCasesSegmentInfoFun, 350),
    [firstTabVal]
  );

  useEffect(() => {
    if (secondTabVal === "Recommendation" && descriptionRef?.current) {
      setIsSubmitActive(descriptionRef?.current?.value?.trim() ? true : false);
    }
  }, [secondTabVal, descriptionRef]);
  useEffect(() => {
    setShowSkeleton(true);
  }, [secondTabVal]);
  useEffect(() => {
    if (displaySecondTab) {
      debounceSegmentsApiCall(secondTabVal);
    }
  }, [secondTabVal, displaySecondTab, rerenderSegmentApiState]);

  useEffect(() => {
    let tabValue = tabValuePairing[firstTabVal];
    const offset = (page - 1) * pageLimit;
    setIsLoading(true);
    getAllApprovalCasesList(firstTabVal, offset)
      .then((data) => {
        if (data?.success) {
          if (!data?.data?.[tabValue]?.length)
            showToast("No Cases Found", "info", true);
          let caseManagementData = data.data?.[tabValue]?.map(
            (item, i, arr) => {
              arr[i] = {
                ...arr[i],
                srNo: offset + i + 1,
                qc_status: item?.qc_status ? "Yes" : "No",
              };
              return arr[i];
            }
          );
          setIsLoading(false);
          setApprovalDataState(caseManagementData);
          setCount(data.data.totalCases);
        } else {
          showToast(data?.message || "Error in fetching list", "error", true);
          setApprovalDataState([]);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        if (
          firstTabVal === "Case" ||
          firstTabVal === "Hospital" ||
          firstTabVal === "Garage" ||
          firstTabVal === "Police"
        ) {
          setApprovalDataState([]);
          showToast(
            err?.response?.data?.message || "Error in fetching list",
            "error",
            true
          );
        } else if (firstTabVal === "Invoice") {
          setCount(5);
          let a = [...ApprovalTableData[1]?.row];
          setApprovalDataState(a);
        } else {
          setApprovalDataState([]);
          showToast("Coming soon", "success", true);
        }
      });
  }, [firstTabVal, page, rerenderApprovalCaseList]);
  useEffect(() => {
    ActionTabContent(firstTabVal);
    if (firstTabVal === "Police") {
      setIsStandardTable(true);
    } else {
      setIsStandardTable(false);
    }
  }, [firstTabVal]);

  const boxStyle = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    ml: { sx: "0", sm: "2.4rem", md: "2.4rem" },
    mt: { sx: "0", sm: "2.4rem", md: "2.4rem" },
  };
  const boxStyleTab = {
    width: "auto",
    marginLeft: "2.4rem",
  };
  let buttonStyle = {
    fontSize: "2.8rem",
    paddingTop: "0.4rem",
    paddingBottom: "0.4rem",
  };
  const match1 = {
    width: "100%",
    marginLeft: "-1.9rem",
    // flexDirection:"column-reverse",
    display: "flex",
  };
  const match2 = {
    width: "100%",
    marginLeft: "-1.9rem",
    flexDirection: "column-reverse",
    display: "flex",
  };

  useEffect(() => {
    if (approvalSegmentInfoState[selectedCollapseId]) {
      const columnData = segmentInfoDetails?.[secondTabVal]?.column?.map(
        (item) => item.id
      );
      const tableCollapseData = Object.keys(
        approvalSegmentInfoState[selectedCollapseId]
      )?.filter((item) => !columnData?.includes(item));
      const tableCollapseDataObj = {};
      tableCollapseData?.forEach((item) => {
        tableCollapseDataObj[item] =
          approvalSegmentInfoState[selectedCollapseId][item];
      });
      setTableCollapseDataState(tableCollapseDataObj);
    }
  }, [secondTabIndex, approvalSegmentInfoState, selectedCollapseId]);

  useEffect(() => {
    if (secondTabVal === "Investigation") {
      setInvestigationActiveTabValue(-1);
    }
  }, [secondTabVal]);
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <Box sx={boxStyle}>
        <Box sx={{ display: "block", width: "100%" }}>
          <Box className={style.box}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: "2rem",
                color: "#3A3A3A",
                // display: { xs: "none", sm: "block", md: "block" },
              }}
            >
              Approvals
            </Typography>
          </Box>
        </Box>
      </Box>
      {/* <div style={{display:"flex",flexDirection:"column",background:"red"}}> */}
      <Box sx={boxStyleTab}>
        <Box sx={matches ? match1 : match2}>
          <MuiTab
            tabs={
              currentRole?.toLowerCase() === "nh"
                ? tabsApproval?.filter(
                    (obj) => obj?.label !== "Garage De-Empanelment"
                  )
                : tabsApproval
            }
            onClick={firstTabChangeClickHandler}
            activeTab={firstTabIndex}
          />
          <div
            className={
              matches ? style.buttonClass : style["buttonClass--matches"]
            }
          >
            <div style={{ width: "max-content" }}>
              {/* <CommonButton
                label=""
                isIcon={true}
                iconName={
                  <TuneIcon
                    sx={{
                      fontSize: "2.8rem",
                      paddingTop: "0.4rem",
                      paddingBottom: "0.4rem",
                    }}
                  />
                }
                backgroundColor={"#E8E8E8"}
                textColor={"#E42125"}
                onClick={filterHandler}
                removeBorder={true}
                smallButton={true}
                filledButton={false}
                removeBackGround={true}
              /> */}
              <div style={{ width: "max-content" }}>
                <FilterPopOver
                  isDateFilterClicked={isDateFilterClicked}
                  isStatusFilterClicked={isStatusFilterClicked}
                  isDateIconClicked={isDateIconClicked}
                  isStatusIconClicked={isStatusIconClicked}
                  isStatusItemClicked={isStatusItemClicked}
                  anchorEl={anchorEl}
                  dateFilterHandler={dateFilterHandler}
                  statusFilterHandler={statusFilterHandler}
                  statusItemHandler={statusItemHandler}
                  startDateHandler={startDateHandler}
                  endDateHandler={endDateHandler}
                  handleFilterByTag={handleFilterByTag}
                  handleClick={handleClick}
                  handleClose={handleClose}
                  handleFilterApply={handleFilterApply}
                  handleFilterReset={handleFilterReset}
                />
              </div>
            </div>

            <div style={{ width: "max-content" }}>
              <CommonButton
                label=""
                isIcon={true}
                iconName={
                  <img
                    src={DownloadIcon}
                    alt="Download Icon"
                    style={buttonStyle}
                  />
                }
                backgroundColor={"#ffffff"}
                textColor={"#E42125"}
                removeBorder={true}
                smallButton={true}
                filledButton={false}
                removeBackGround={true}
                onClick={() => showToast("Coming soon", "info", true)}
              />
            </div>
          </div>
        </Box>
        <CommonModal
          // showCrossIcon={actionModalType === "Vendor Assessment" ? true : false}
          showCrossIcon={true}
          label={actionModalType === "Peer Review" ? "Peer Review" : ""}
          width={actionModalType === "Vendor Assessment" ? "45%" : "30%"}
          height={actionModalType === "Grade Case" ? "45rem" : "none"}
          open={openActionModal}
          onClose={() => setOpenActionModal(false)}
        >
          {renderActionComponent()}
        </CommonModal>
        {!isLoading ? (
          <TableComponent
            stickyHeader={false}
            columnHeaderBackgroundColor={"#FCF7FF"}
            columnHeaderColor={"#242424"}
            columnHeaderFontWeight={600}
            columnBodyFontWeight={400}
            page={page}
            rowsPerPage={rowsPerPage}
            count={count}
            firstButtonClicked={firstButtonClicked}
            lastButtonClicked={lastButtonClicked}
            handleNextButtonClick={handleNextButtonClick}
            handleBackButtonClick={handleBackButtonClick}
            onPageDropdownChange={onPageDropdownChange}
            setPage={setPage}
            alternnateStyledRow={true}
            alternnateStyledRowColor={"#FBF5FF"}
            rowsData={approvalDataState}
            columnsData={ApprovalTableData?.[firstTabIndex]?.column}
            hideBorders={true}
            secondPopperListItem={actionTabState}
            // onClickSecondPopper={onClickSecondPopper}
            // onCloseSecondPopper={onCloseSecondPopper}
            onClickFirstPopper={onClickFirstPopper}
            popperContentMatch={firstTabIndex === 5 ? "profile" : "case_id"}
            onCellClicked={onCellClicked}
            isApproval={true}
            unFlagApiClick={unFlagApiClick}
            caseId={activeCaseId}
            displaySecondTab={displaySecondTab}
            openActionModal={openActionModal}
            activeMenu="approval"
            firstTabVal={firstTabVal}
            isStandardTable={isStandardTable}
            actionPopperRef={actionPopperRef}
          />
        ) : (
          <TableSkeleton />
        )}
        {displaySecondTab && (
          <>
            <MuiTab
              tabs={tabs2Approval[firstTabIndex].headerVal}
              variant="standard"
              onClick={secondTabChangeClickHandler}
              ref={viewTableRef}
              activeTab={secondTabIndex}
            />
            <Box sx={{ marginTop: "10px" }}>
              {gridViewTabs.includes(secondTabVal) ? (
                Object.keys(approvalSegmentInfoState)?.length &&
                showSkeleton ? (
                  <TableGrid
                    gridContent={
                      approvalSegmentInfoState?.[0]
                        ? approvalSegmentInfoState?.[0]
                        : approvalSegmentInfoState
                    }
                    isDocument={
                      approvalSegmentInfoState?.documents?.length ? true : false
                    }
                    backgroundColor="#FFFFFF"
                    boxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                    documentDetails={approvalSegmentInfoState?.documents}
                  />
                ) : (
                  <TableGridSkeleton />
                )
              ) : secondTabVal === "Investigation" ? (
                <Investigation
                  caseId={selectedCaseId?.current}
                  investigationsActiveTabValue={investigationsActiveTabValue}
                  setInvestigationActiveTabValue={
                    setInvestigationActiveTabValue
                  }
                  setVendorBlockIsClicked={setVendorBlockIsClicked}
                  vendorBlockisClicked={vendorBlockisClicked}
                  setIsVendorClicked={setIsVendorClicked}
                  isVendorClicked={isVendorClicked}
                  firstTabIndex={firstTabIndex}
                  secondTabIndex={secondTabIndex}
                  setRerenderApprovalCaseList={() =>
                    setRerenderApprovalCaseList((prev) => !prev)
                  }
                  firstTabVal={firstTabVal}
                />
              ) : secondTabVal === "CHASE Smart" ? (
                Object.keys(approvalSegmentInfoState)?.length &&
                showSkeleton ? (
                  <ExternalInformation
                    backgroundColor="#FFFFFF"
                    boxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                    data={approvalSegmentInfoState}
                    documentDetails={
                      segmentInfoDetails?.[secondTabVal]?.documentDetails
                    }
                  />
                ) : (
                  <TableGridSkeleton showProfileSkeleton />
                )
              ) : secondTabVal === "Recommendation" ? (
                <RecommendationTabelGrid
                  selectedCaseData={approvalDataState?.find(
                    (obj) => obj?.case_id == activeCaseId
                  )}
                  gridContent={approvalSegmentInfoState}
                  firstTabVal={firstTabVal}
                  secondTabVal={secondTabVal}
                  setIsSubmitActive={setIsSubmitActive}
                  setRerenderSegmentApiState={setRerenderSegmentApiState}
                />
              ) : secondTabVal === "FCU Actions" ? (
                <RecommendationTabelGrid
                  selectedCaseData={approvalDataState?.find(
                    (obj) => obj?.case_id == activeCaseId
                  )}
                  gridContent={{ rlmu: rlmuData }}
                  firstTabVal={firstTabVal}
                  secondTabVal={secondTabVal}
                  setIsSubmitActive={setIsSubmitActive}
                  setRerenderSegmentApiState={setRerenderSegmentApiState}
                />
              ) : Object.keys(approvalSegmentInfoState)?.length &&
                showSkeleton ? (
                <TableComponent
                  rowsData={approvalSegmentInfoState}
                  columnsData={segmentInfoDetails?.[secondTabVal]?.column}
                  hideColumnWithId={currentRole !== "IM" ? "create_case" : null}
                  TableCollapseContent={tableCollapseDataState}
                  onCellClicked={onCellClicked}
                  open={openCollapse}
                  setOpen={setOpenCollapse}
                  TableCollapseContentDocument={false}
                  tablePagination={false}
                  hideBorders={true}
                  paddingLeftHeaderStyledTableCell="3px"
                  paddingHeaderStyledTableCell="4.5px"
                  paddingBodyStyledTableCell="4.5px"
                  columnHeaderColor={"#E42125"}
                  columnHeaderFont="1.2rem"
                  columnHeaderFontWeight={600}
                  columnBodyFont="1.2rem"
                  columnBodyFontWeight={500}
                  paddingBody=".5rem"
                  paddingHeader=".75rem"
                  tableBoxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
                  tableBorder={""}
                  tablePadding="1.5rem 0rem"
                  createCaseClickHandler={() => navigate("/createCase")}
                />
              ) : (
                <TableGridSkeleton />
              )}
              {secondTabVal === "Risk Details" && (
                <Box>
                  <Typography
                    sx={{
                      font: "Inter",
                      fontWeight: 500,
                      fontSize: "1.4rem",
                      color: "#505050",
                      margin: "15px 0 10px 0",
                    }}
                  >
                    {lobName?.toLowerCase() === "motor"
                      ? "Motor Trigger"
                      : "Health Trigger"}
                  </Typography>
                  {Object.keys(approvalSegmentInfoState)?.length &&
                  showSkeleton ? (
                    <TableComponent
                      stickyHeader={false}
                      columnHeaderBackgroundColor={"#FFDFCB"}
                      columnHeaderColor={"#242424"}
                      columnHeaderFontWeight={600}
                      columnBodyFontWeight={400}
                      rowsData={approvalSegmentInfoState?.triggers || []}
                      columnsData={motorTriggerTable?.column}
                      hideBorders={true}
                      tablePagination={false}
                      isNoDataRow={true}
                    />
                  ) : (
                    <TableSkeleton rows={1} pagination={false} />
                  )}
                </Box>
              )}
              {secondTabVal === "FCU Actions" ||
              secondTabVal === "Investigation" ||
              (secondTabVal === "Recommendation" &&
                approvalDataState?.find((obj) => obj?.case_id == activeCaseId)
                  ?.flag === "false") ? null : (
                <CommonDescription
                  heading={
                    secondTabVal === "Recommendation" ? "Remark" : "Description"
                  }
                  placeholder={
                    secondTabVal === "Recommendation"
                      ? "Enter Remark"
                      : "Enter Description"
                  }
                  isSubmitActive={isSubmitActive}
                  onSubmitButton={onSubmitButton}
                  descriptionRef={descriptionRef}
                />
              )}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Approval;
